import { COMMERCIAL_PROPERTY_TYPE } from "@/components/survey/_constants/surveyQuestions";
import { workTypesToLabel } from "@/components/get-in-touch/_constants/workTypes";

function workTypesToScope(workTypes = []) {
  const label = workTypesToLabel(workTypes);
  return label || null;
}

function toDesignPresent(hasDesigns) {
  if (hasDesigns === "Yes") return true;
  if (hasDesigns === "No") return false;
  return null;
}

/**
 * Maps local form/survey state into the v2 Lead Gen API request shape (see
 * the ClickUp "Lead Gen V2 Contracts" doc, "Create Lead Gen").
 */
export function buildLeadGenPayload({ digitalProfile, mandatoryData, surveyAnswers = {} }) {
  const siteLocationDetails = mandatoryData?.siteLocationDetails || {};

  return {
    contractorUserId: digitalProfile?.contractorId ?? null,
    contractorNumber: digitalProfile?.phoneNumber ?? null,
    contractorName: digitalProfile?.profileName ?? null,
    projectDetails: {
      propertyType: surveyAnswers.propertyType ?? null,
      area:
        (surveyAnswers.propertyType === COMMERCIAL_PROPERTY_TYPE ? surveyAnswers.sqft : surveyAnswers.bhk) ?? null,
      budget: surveyAnswers.budget ?? null,
      timeline: surveyAnswers.timeline ?? null,
      workScope: workTypesToScope(mandatoryData?.workTypes),
      isDesignPresent: toDesignPresent(surveyAnswers.hasDesigns),
    },
    comments: null,
    homeownerName: mandatoryData?.fullName ?? null,
    homeownerNumber: mandatoryData?.contactNumber ?? null,
    address: {
      name: siteLocationDetails.name || "Untitled",
      flatNo: mandatoryData?.flatNumber ?? null,
      addressLine1: siteLocationDetails.addressLine1 ?? mandatoryData?.siteLocation ?? null,
      landmark: null,
      city: siteLocationDetails.city ?? null,
      state: siteLocationDetails.state ?? null,
      country: "India",
      pincode: siteLocationDetails.pincode ? Number(siteLocationDetails.pincode) : null,
      latitude: siteLocationDetails.lat != null ? String(siteLocationDetails.lat) : null,
      longitude: siteLocationDetails.lng != null ? String(siteLocationDetails.lng) : null,
      stateCode: siteLocationDetails.stateCode ?? null,
      locality: siteLocationDetails.locality ?? null,
    },
  };
}
